module.exports = __webpack_public_path__ + "assets/GTAmerica-ExpandedRegular.eot";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/fonts/GTAmerica-ExpandedRegular.eot
// module id = 1002
// module chunks = 19